import React, { useEffect, useState } from 'react';
// ⚠️ Path confirmed from your project: character lives directly in src/assets/
import character from '../assets/character.png';
import './MascotCorner.css';

const FALLBACK_NAV_HEIGHT = 70; // only used before the real nav height is measured
const GAP_ABOVE_NAV = 14;

export default function MascotCorner({ text, onDismiss }) {
  const [bottomOffset, setBottomOffset] = useState(FALLBACK_NAV_HEIGHT + GAP_ABOVE_NAV);

  // Measures the real BottomNav height at runtime instead of guessing a
  // fixed number — stays correct even as .bottom-nav's own CSS changes
  // across its breakpoints (60px / 65px / 70px / 50px landscape, etc.)
  useEffect(() => {
    const measure = () => {
      const nav = document.querySelector('.bottom-nav');
      const navHeight = nav ? nav.getBoundingClientRect().height : FALLBACK_NAV_HEIGHT;
      setBottomOffset(navHeight + GAP_ABOVE_NAV);
    };

    measure();
    window.addEventListener('resize', measure);
    window.addEventListener('orientationchange', measure);
    return () => {
      window.removeEventListener('resize', measure);
      window.removeEventListener('orientationchange', measure);
    };
  }, []);

  return (
    <div
      className="mascot-corner"
      role="status"
      onClick={onDismiss}
      aria-label="Dismiss message"
      style={{ bottom: `calc(${bottomOffset}px + env(safe-area-inset-bottom))` }}
    >
      <div className="mascot-corner__glow" aria-hidden="true" />
      <img className="mascot-corner__character" src={character} alt="" aria-hidden="true" />
      <div className="mascot-corner__paper">
        <p className="mascot-corner__text">{text}</p>
      </div>
    </div>
  );
}